import { Injectable } from '@angular/core';

import { PlatformEndpointService } from '../../communicator/endpoint/endpoint.service';
import {
  PlatformCommunicatorAuthService,
} from '../../communicator/platform-communicator/platform-communicator.auth.service';
import { LoadingService } from '../../loading/loading.service';
import { ParametersService } from '../../parameters/parameters.service';

declare const CV_JS: any;

@Injectable({
  providedIn: 'root',
})
export class CryptoVaultService {

  constructor(
    private parametersService: ParametersService,
    private endpointService: PlatformEndpointService,
    private authService: PlatformCommunicatorAuthService,
    private loadingService: LoadingService,
  ) {

  }

  async keyExchange(transactionId: string) {
    console.warn('Entró en negociación de llaves por keyCipherExchange ------');
    this.loadingService.show();
    const token = this.authService.getSSOInformation().accessToken;
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    };
    await CV_JS.keyExchange(
      transactionId,
      this.parametersService.getParameter('criptovault').time_expiration,
      this.parametersService.getParameter('criptovault').time_grace,
      this.endpointService.URLS.CRYPTO_KEY_SERVER,
      this.endpointService.URLS.CRYPTO_KEY_CLIENT,
      headers,
      {},
    );
  }

  encrypt(message: string) {
    return new Promise<any>((resolve, reject) => {
      CV_JS.encrypt(message)
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  decrypt(message: string) {
    return CV_JS.decrypt(message);
  }

  async refreshKeyCrypto() {
    this.loadingService.show();
    await CV_JS.refreshKey().then(() => this.loadingService.hide())
      .catch(() => this.loadingService.hide());
  }

  clear() {
    return CV_JS.clear();
  }
}
